import React from 'react'

export default function EmailToYourself(props) {
    return (
        <div className="section-container">
            <div className='checkbox'>
                <input 
                    type="checkbox" 
                    id="email-to-yourself" 
                    name="email-to-yourself" 
                    checked={props.isChecked}
                    onChange={props.handleCheckboxChange}
                    />
                <label htmlFor="email-to-yourself">
                    <span className='title'>YES! Please send me travel advice, tips and inspiration from Indie Travel Guru.</span>
                    <span className='text'>(You can leave the list any time, and we never share your info with others)</span>
                </label>
            </div>
        </div>
    )
}
